var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-dialog", {
    attrs: {
      transition: "dialog-top-transition",
      "max-width": _vm.evalSize(),
      "max-height": "80vh"
    },
    scopedSlots: _vm._u(
      [
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              !_vm.icon
                ? _c(
                    "AppButton",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "ml-2 mr-2",
                          attrs: { xLarge: _vm.large, disabled: _vm.disabled },
                          domProps: { textContent: _vm._s(_vm.activatorText) }
                        },
                        "AppButton",
                        attrs,
                        false
                      ),
                      on
                    )
                  )
                : _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        { attrs: { disabled: _vm.disabled, icon: "" } },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", {
                        staticClass: "secondary--text",
                        domProps: { textContent: _vm._s(_vm.activatorText) }
                      })
                    ],
                    1
                  )
            ]
          }
        },
        {
          key: "default",
          fn: function(dialog) {
            return [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { staticClass: "primary white--text" },
                    [
                      _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-5",
                                            attrs: { color: "white" },
                                            domProps: {
                                              textContent: _vm._s(
                                                "mdi-information-outline"
                                              )
                                            }
                                          },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.hint))])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pa-5" },
                    [
                      _vm._t("default", function() {
                        return [_vm._v("Dialog text")]
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center" },
                    [
                      _c("AppButton", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.action,
                            expression: "action"
                          }
                        ],
                        attrs: { xLarge: "", disabled: _vm.actionDisabled },
                        domProps: { textContent: _vm._s(_vm.action) },
                        on: { click: _vm.actionClick }
                      }),
                      _vm._v(" "),
                      _c("AppButton", {
                        staticClass: "secondary",
                        attrs: { xLarge: "" },
                        domProps: { textContent: _vm._s("Close") },
                        on: {
                          click: function($event) {
                            dialog.value = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    ),
    model: {
      value: _vm.dialog,
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }